import add from './add';

const module = {
  namespaced: true,
  modules: {
    add,
  },
};

export default module;
